import {
  DirectionsBoatIcon,
  DirectionsRailwayIcon,
  LocalAirportIcon,
  SeaAirIcon,
  SvgIconProps,
  TPBargeIcon,
  TPTruckIcon,
} from '@freighthub/silhouette-core'
import { ComponentType, FC } from 'react'

import {
  TRANSPORT_MODE_AIR,
  TRANSPORT_MODE_BARGE,
  TRANSPORT_MODE_RAIL,
  TRANSPORT_MODE_SEA,
  TRANSPORT_MODE_SEA_AIR,
  TRANSPORT_MODE_TRUCK,
  TTransportOrCarriageMode,
} from '../domain/TransportMode'

export const TransportModeIconsMap: Record<TTransportOrCarriageMode, ComponentType<SvgIconProps>> = {
  [TRANSPORT_MODE_TRUCK]: TPTruckIcon,
  [TRANSPORT_MODE_SEA]: DirectionsBoatIcon,
  [TRANSPORT_MODE_AIR]: LocalAirportIcon,
  [TRANSPORT_MODE_RAIL]: DirectionsRailwayIcon,
  [TRANSPORT_MODE_SEA_AIR]: SeaAirIcon,
  [TRANSPORT_MODE_BARGE]: TPBargeIcon,
}

type TTransportModeIconProps = {
  transportMode: TTransportOrCarriageMode
} & SvgIconProps

export const TransportModeIcon: FC<TTransportModeIconProps> = (props) => {
  const { transportMode, ...rest } = props
  const Icon: ComponentType<SvgIconProps> = TransportModeIconsMap[transportMode]
  return <Icon {...rest} />
}
